import React from 'react';

const ExecutionCyclesPage = () => <h1>Execution Cycles</h1>;

export default ExecutionCyclesPage;